export enum ReferralsRoutes {
  root = 'referrals',
  referralsFull = 'organization/referrals',
}
